import { apiClient } from '../services/http';
import toast from 'react-hot-toast';

/**
 * Open an authenticated (protected) upload file in a new tab.
 * Uses cookie-authenticated apiClient and opens a blob URL.
 */
export async function openProtectedFile(filename) {
  if (!filename) return;
  try {
    const { data } = await apiClient.get(`/uploads/${encodeURIComponent(filename)}`, {
      responseType: 'blob'
    });
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank', 'noopener,noreferrer');
    setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  } catch (e) {
    toast.error(e.response?.status === 401 ? 'Please log in to view files' : 'Failed to open file');
  }
}
